import React, { useState } from "react";

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What are content marketing services?",
      answer:
        "Content marketing services involve creating and distributing valuable, relevant content to attract, engage, and convert your target audience into customers, helping improve brand visibility and business growth.",
    },
    {
      question: "Why is content marketing important for businesses?",
      answer:
        "Content marketing helps businesses build trust, improve search engine rankings, generate leads, and increase customer engagement through informative and valuable content.",
    },
    {
      question: "How does a content marketing company help my business?",
      answer:
        "A content marketing company creates strategic content plans, produces high-quality content, and optimizes it for SEO to drive traffic, generate leads, and improve conversions.",
    },
    {
      question: "What types of content are included in content marketing?",
      answer:
        "Content marketing includes blogs, website content, social media posts, email campaigns, videos, infographics, and more to engage and convert your audience effectively.",
    },
    {
      question:
        "How long does content marketing take to show results?",
      answer:
        "Content marketing is a long-term strategy. Typically, you can start seeing noticeable results like traffic and engagement improvements within 3 to 6 months.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="k-faq-section">
      <div className="k-faq-container">
        <h2 className="k-faq-heading">Frequently Asked Questions</h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            className={activeIndex === index ? "k-faq-box active" : "k-faq-box"}
          >
            <div className="k-faq-question" onClick={() => toggleFAQ(index)}>
              <span className="k-faq-title">{item.question}</span>
              <span className="k-faq-arrow">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>

            <div className="k-faq-answer">
              <p className="k-faq-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
